import React, { useState } from 'react';
import KDSStylingSettings from './Components/StylingSettings';
import KDSSettingsList from './Components/KDSSettings';
import styled from '@emotion/styled';
import { Box } from '~Styles';
import Toggle from '~ComponentsImproved/Toggle';

const Wrapper = styled.div`
  padding: 0 28px 20px;
`;

const KDSSettings = () => {
  return (
    <Wrapper>
      <Box marginBottom="xl">
        <KDSSettingsList />
      </Box>
      <KDSStylingSettings />
    </Wrapper>
  );
};

export default KDSSettings;
